import * as React from "react";
import { styled } from "@mui/material/styles";
import { AppUrl } from "../../../config";
import { Link } from "react-router-dom";

const PREFIX = "Breadcrumbs";

const classes = {
  linkStyle: `${PREFIX}-linkStyle`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.linkStyle}`]: {
    "fontSize": "14px",
    "margin": "-12px auto 16px auto",
    "& a": {
      color: theme.palette.primary.main,
      textDecoration: "underline",
      padding: "0px 5px",
    },
    "& a:focus, & a:hover": {
      color: "#BB3300",
      backgroundColor: "#E6F3FF",
    },
    "& a:active": {
      color: "#fff",
      backgroundColor: theme.palette.primary.main,
      textDecoration: "none",
    },
  },
}));

export interface Props {
  currentPageBreadCrumbTitle: string;
  resetState: (app: string) => void;
  currentApp: string;
}

const reportsAndComparisonsApps = [
  "Financial/Regulatory Search & Reporting",
  "Standard Comparisons",
  "Customized Comparisons",
  "Manage Custom Content",
];

const bulkDataApps = ["Bulk Data Download", "API Documentation", "API 101"];

const summaryOfDepositsApps = [
  "Summary Tables",
  "Market Share",
  "Branch Office Deposits",
  "Custom Data Download",
  "Manage Custom Content",
];

const links = (
  <>
    <>
      <a href="https://www.fdic.gov/">Home</a> &gt;
    </>
    <>
      <a href="https://www.fdic.gov/resources/">Resources</a> &gt;
    </>
    <>
      <a href="https://www.fdic.gov/resources/data-tools/">Data Tools</a> &gt;
    </>
  </>
);

const Breadcrumbs = ({
  currentPageBreadCrumbTitle,
  resetState,
  currentApp,
}: Props) => {
  const [effectiveApp, setEffectiveApp] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (currentApp !== "peerGroup") {
      setEffectiveApp(currentApp);
    }
  }, [currentApp]);

  return (
    <Root>
      {currentPageBreadCrumbTitle !== "BankFind Suite" ? (
        <div id="breadcrumbs" className={classes.linkStyle}>
          {links}
          <Link
            to={AppUrl("HomePage")}
            onClick={() => {
              resetState(currentApp);
            }}
          >
            BankFind Suite
          </Link>
          {reportsAndComparisonsApps.includes(currentPageBreadCrumbTitle) &&
            effectiveApp !== "SOD" && (
              <>
                &gt;
                <Link
                  to="/financialreporting"
                  onClick={() => {
                    resetState(currentApp);
                  }}
                >
                  Reports and Comparisons
                </Link>
              </>
            )}
          {bulkDataApps.includes(currentPageBreadCrumbTitle) && (
            <>
              &gt;
              <Link
                to="/bulkData"
                onClick={() => {
                  resetState(currentApp);
                }}
              >
                Bulk Data and API
              </Link>
            </>
          )}
          {summaryOfDepositsApps.includes(currentPageBreadCrumbTitle) &&
            effectiveApp === "SOD" && (
              <>
                &gt;
                <Link
                  to="/sod"
                  onClick={() => {
                    resetState(currentApp);
                  }}
                >
                  Summary of Deposits
                </Link>
              </>
            )}
          &gt; {currentPageBreadCrumbTitle}
        </div>
      ) : (
        <div id="breadcrumbs" className={classes.linkStyle}>
          {links} {currentPageBreadCrumbTitle}
        </div>
      )}
    </Root>
  );
};

export default Breadcrumbs;
